import { render } from "./OrthoPatients.vue?vue&type=template&id=94fa17e6"
import script from "./OrthoPatients.vue?vue&type=script&lang=js"
export * from "./OrthoPatients.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__